export default "__VITE_ASSET__f859bc5b__"